/* eslint-disable import/prefer-default-export */
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import 'dayjs/locale/ja'

dayjs.locale('ja')
dayjs.extend(utc)
dayjs.extend(timezone)

export const DATE_FORMAT = 'MM.DD(ddd) HH:mm'
export const JST_TIMEZONE = 'Asia/Tokyo'

export const formatFullDate = (day: string | Date | dayjs.Dayjs): string => {
  return dayjs(day).format('YYYY年M月D日 (ddd)')
}

export const formatSimpleDate = (day: string | Date | dayjs.Dayjs): string => {
  return dayjs(day).format('YYYY-MM-DD')
}

export const formatShortDateTime = (
  day: string | Date | dayjs.Dayjs
): string => {
  return dayjs(day).format('MM月DD日 (ddd) HH:mm')
}

export const formatSlashDate = (day: string | Date | dayjs.Dayjs): string => {
  return dayjs(day).format('YYYY/MM/DD')
}

export const formatEightDigitDate = (
  day: string | Date | dayjs.Dayjs
): string => {
  return dayjs(day).format('YYYYMMDD')
}

export const formatDateWithDayOfWeek = (
  day: string | Date | dayjs.Dayjs
): string => {
  return dayjs(day).format('YYYY-MM-DD(dd)')
}

export const formatDateTime = (day: string | Date | dayjs.Dayjs): string => {
  return dayjs(day).format('MM-DD(dd) HH:mm')
}

export const formatDateWithTimeAndWeekday = (
  day: string | Date | dayjs.Dayjs | undefined
): string => {
  return dayjs(day).format('YYYY-MM-DD(dd) HH:mm')
}

export const formatDateTimeWithDayOfWeek = (
  day: string | Date | dayjs.Dayjs | undefined
): string => {
  return dayjs(day).format('YYYY/MM/DD(ddd) HH:mm')
}

// 不正な日付文字列 (URL クエリ改ざん等) で throw するのを防ぐ。
// dayjs.tz は不正値で即 throw するため、先に通常パースで妥当性を確認する
const toJstDayjsOrNow = (date: string | Date | dayjs.Dayjs): dayjs.Dayjs => {
  return dayjs(date).isValid()
    ? dayjs.tz(date, JST_TIMEZONE)
    : dayjs().tz(JST_TIMEZONE)
}

export const toJstStartOfDayISO = (
  date: string | Date | dayjs.Dayjs
): string => {
  return toJstDayjsOrNow(date).startOf('day').toISOString()
}

export const toJstEndOfDayISO = (date: string | Date | dayjs.Dayjs): string => {
  return toJstDayjsOrNow(date).endOf('day').toISOString()
}
